import { render } from "./About.vue?vue&type=template&id=c1223a98"
const script = {}
script.render = render

export default script